import { required } from 'vuelidate/lib/validators'
import formValidator from '@/mixins/form-validator.js'
import axios from 'axios'
import toastStore from '@/stores/toast-store.js'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import PrefixesMixin from '@/mixins/prefixes.js'
import sessionStore from '@/stores/session-store.js'
import parentRoute from '@/mixins/parent-route.js'

export default {
  phone: 'Verification',
  mixins: [formValidator, CurrentUserResolver, PrefixesMixin, parentRoute],
  data: function () {
    return {
      errors: {},
      submitted: false,

      user: {
        firstCharacter: '',
        secondCharacter: '',
        thirdCharacter: '',
        fourthCharacter: '',
      },

      smsSend: false,
      firstAttempt: true,
      blocker: false,
      validatedItemKey: 'user',
    }
  },
  watch: {
    user: {
      handler: function () {
        this.firstAttempt &&
        !!this.user.firstCharacter &&
        !!this.user.secondCharacter &&
        !!this.user.thirdCharacter &&
        !!this.user.fourthCharacter
          ? this.saveAndClear()
          : null
      },
      deep: true,
    },
  },
  mounted() {
    this.$refs.firstCharacter.focus()
    // !localStorage.getItem('verificationCodeSent') ? this.sendVerificationCode() : null;
    // localStorage.setItem('verificationCodeSent', 'true');
  },
  methods: {
    saveAndClear() {
      this.save()
      let _this = this
      setTimeout(() => {
        _this.user.firstCharacter = ''
        _this.user.secondCharacter = ''
        _this.user.thirdCharacter = ''
        _this.user.fourthCharacter = ''
        this.$refs.firstCharacter.focus()
      }, 100)
    },

    save: function (e) {
      !!e ? e.preventDefault() : null
      this.submitted = true
      this.validateForm()

      if (Object.keys(this.errors).length > 0) {
        toastStore.commit('error', {
          message: this.$t('messages.validationErrorFillFields'),
        })
      } else {
        this.blocker = true
        axios({
          method: 'put',
          url: `users/${this.currentUser.id}/verify_phone`,
          data: {
            user: {
              phone: this.currentUser.phone,
              phonePrefix: this.currentUser.phonePrefix,
              phone_verification_code: `${this.user.firstCharacter}${this.user.secondCharacter}${this.user.thirdCharacter}${this.user.fourthCharacter}`,
            },
          },
        })
          .then(response => {
            sessionStore.commit('setUser', response.data)
            toastStore.commit('success', {
              message: this.$t('profile.phone.verification.verificationSuccesToast'),
            })
            this.$router.push('/profile')
            this.blocker = false
          })
          .catch(error => {
            let errorMessage = !!error.response.data.errors
              ? Object.values(error.response.data.errors).join(', ')
              : this.$t('messages.error')
            toastStore.commit('error', { message: errorMessage })
            this.blocker = false
          })
      }
    },

    changeFocus(key) {
      // console.log('handleInputFocus key', key);
      if (key == 'firstCharacter') {
        this.$refs.secondCharacter.focusManual()
      } else if (key == 'secondCharacter') {
        this.$refs.thirdCharacter.focusManual()
      } else if (key == 'thirdCharacter') {
        this.$refs.fourthCharacter.focusManual()
      } else if (key == 'fourthCharacter') {
        this.$refs.fourthCharacter.focusOut()
      }
    },

    focusBack(key) {
      // console.log('focusBack key', key);
      if (key == 'secondCharacter') {
        this.$refs.firstCharacter.focusManual()
      } else if (key == 'thirdCharacter') {
        this.$refs.secondCharacter.focusManual()
      } else if (key == 'fourthCharacter') {
        this.$refs.thirdCharacter.focusManual()
      }
    },

    sendVerificationCode: function () {
      if (!!this.currentUser && !!this.currentUser.id) {
        this.blocker = true
        axios({
          method: 'put',
          url: `users/${this.currentUser.id}/start_phone_verification`,
          data: {
            id: this.currentUser.id,
          },
        })
          .then(response => {
            sessionStore.commit('setUser', response.data)
            this.$router.push('verification')

            toastStore.commit('success', {
              message:
                this.$t('profile.phone.verification.resendCodeMessage') +
                ` +${response.data.phonePrefix} ${response.data.phone}`,
            })
            this.blocker = false
          })
          .catch(error => {
            let errorMessage = !!error.response.data.errors
              ? Object.values(error.response.data.errors).join(', ')
              : this.$t('messages.error')
            toastStore.commit('error', { message: errorMessage })
            this.blocker = false
          })
      }
    },
  },
  validations() {
    if (this.submitted) {
      return {
        user: {
          firstCharacter: {
            required,
          },
          secondCharacter: {
            required,
          },
          thirdCharacter: {
            required,
          },
          fourthCharacter: {
            required,
          },
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
